import commonUtil from '../../utils/commonUtil';

// { url: '/api/createEvent', method: 'POST', data: userData }
const cacheRequests = {
  flushcache(values, callback) {
    const response = commonUtil.triggerServerRequest({ url: '/api/flushcache', method: 'POST' });
    if (typeof callback === 'function') {
      callback(response);
    }
  },

  deletecache(cacheKey, callback) {
    const response = commonUtil.triggerServerRequest({ url: '/api/deletecache?key=' + cacheKey, method: 'GET' });
    if (typeof callback === 'function') {
      callback(response);
    }
  },
};
export default cacheRequests;
